export const DATA_ITEM = 'data-item';
export const SHOP_ITEM = 'shop-item';
export const SHOP_ITEM_CATEGORY = 'shop-item-category';



// WEBPACK FOOTER //
// ./app/constants/CART_KEY.ts